export default "__VITE_ASSET__BGWvbtIf__"